import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import musicApp from "../../Assets/Projects/music_app.jpeg";
import emotion from "../../Assets/Projects/instagram.jpeg";
import drag_and_drop_todo_app from "../../Assets/Projects/drag_and_drop_todo_app.jpeg";
import eCommerce from "../../Assets/Projects/e-commerce.jpeg";
import quizApp from "../../Assets/Projects/quiz_app.jpeg";
import calculator from "../../Assets/Projects/calculator.jpeg";
import facebook from "../../Assets/image/facebook ui.PNG";
import Ecommerce from "../../Assets/image/ecommer.PNG"
import Admin_panal from "../../Assets/image/admin.PNG"
import Todo from "../../Assets/image/Todo app.PNG"
import salani from "../../Assets/image/salani.PNG"
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";

function Projects () {
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'ProjectData'));
        const citiesData = [];
        querySnapshot.forEach((doc) => {
          citiesData.push({ id: doc.id, ...doc.data() });
        });
        setCities(citiesData);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    fetchData();
  }, []); 
  console.log(cities);
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        
          {cities.map((project) => (
            <Col md={4} key={project.id} className="project-card">
              <ProjectCard
              imgPath={project.image}
              isBlog={project.isBlog}
              title={project.title}
              description={project.description}
              ghLink={project.githubLink}
              demoLink={project.demoLink}
            />
              {/* Render other project information here */}
            </Col>
          ))}
        
          {/* <Col md={4} className="project-card">
            <ProjectCard
              imgPath={calculator}
              isBlog={false}
              title="Calculator"
              description="I have created this calculator which is fully responsive and quite stylish."
              ghLink="https://github.com/Huzaifa829/calculator-bugt"
              demoLink="https://effulgent-taffy-04081e.netlify.app"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Ecommerce}
              isBlog={false}
              title="E-commerce website with Firebase"
              description="Made An E-commerces Website with FireBase."
              ghLink="https://github.com/Huzaifa829/e-commerce"
              demoLink="https://login-page-test-eab99.web.app"            
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Admin_panal}
              isBlog={false}
              title="Admin Panal"
              description="Create admin with firebase."
              ghLink="https://github.com/Huzaifa829"
              demoLink="https://admin-panal-ce083.web.app"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Todo}
              isBlog={false}
              title="Todo App"
              description="Todo App with firebase"
              ghLink="https://github.com/Huzaifa829/todoApp"
              demoLink="https://todoapp-94302.web.app"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={salani}
              isBlog={false}
              title="Salani Ui"
              description="Form with ui and functionalty."
              ghLink="https://github.com/Huzaifa829"
              demoLink="https://salani-form-practice.netlify.app"
            />
          </Col> */}
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
